// This file is auto-generated. Run `pnpm generate:icons` to regenerate.
// biome-ignore-all assist/source/organizeImports: Generated file.
// biome-ignore-all format: Generated file.
import type { IconComponent, IconName } from "./icon-types";

type IconModule = { default: IconComponent };
type LazyIconName = Exclude<IconName, keyof typeof import("./core-icon-registry").coreIconRegistry>;

export const lazyIconNames = [
  "add-photo",
  "add-plus",
  "advanced-readings",
  "ai-filled",
  "ai",
  "alert-exclamation",
  "alerts-outline",
  "angles-up-down-solid",
  "api",
  "arrow-drop-down",
  "arrow-right-regular",
  "arrow-right",
  "art-service",
  "assign-link",
  "barcode-scan-regular",
  "bars-filter-regular",
  "bookmark-regular",
  "bookmark-solid",
  "calendar-solid",
  "camera-regular",
  "check-circle",
  "circle-check-regular",
  "circle-minus-solid",
  "circle-navigation",
  "circle-play-solid",
  "circle-plus-regular",
  "circle-question",
  "circle-stop-regular",
  "circle-xmark-solid",
  "cloud-slash-regular",
  "collect",
  "collection-taken",
  "command-search",
  "component",
  "configure-slider",
  "copy-regular",
  "cost-savings-dollar",
  "developing-stage",
  "document-upload",
  "dollar-sign",
  "dot",
  "download",
  "drag",
  "early-stage",
  "edit-pen",
  "email-envelope",
  "expand-regular",
  "expand",
  "eye-slash-regular",
  "flash-auto",
  "flash-off",
  "flash-on",
  "gauge-max-solid-full",
  "grid",
  "grip-drag",
  "hazardous",
  "hwe-sensor-triangle",
  "invoke-reading-bolt-regular",
  "invoke-reading-bolt-solid",
  "line",
  "logout-exit",
  "marketplace",
  "mature-stage",
  "message",
  "microphone-solid",
  "minus",
  "new-message",
  "new-nxt-step",
  "note-regular",
  "paper-plane-top",
  "partners",
  "phone",
  "qr-code-scan",
  "quarterly-collection",
  "report-error-square-regular",
  "rotate",
  "save",
  "send",
  "service",
  "settings-cog-solid",
  "share",
  "signal-connection",
  "signal",
  "sort-lines",
  "stacked-images-regular",
  "sync",
  "tag",
  "temperature-high-regular-full",
  "thumbs-down",
  "thumbs-up",
  "trash-delete-bin",
  "triangle-exclamation-solid",
  "ultrasound",
  "up-down",
  "vero",
  "vibration",
  "watching",
  "wifi-exclamation-sharp-solid",
  "wifi",
  "zoom-in",
  "zoom-out",
] as const satisfies readonly LazyIconName[];

export const lazyIconLoaders = {
  "add-photo": () => import("./generated/add-photo"),
  "add-plus": () => import("./generated/add-plus"),
  "advanced-readings": () => import("./generated/advanced-readings"),
  "ai-filled": () => import("./generated/ai-filled"),
  "ai": () => import("./generated/ai"),
  "alert-exclamation": () => import("./generated/alert-exclamation"),
  "alerts-outline": () => import("./generated/alerts-outline"),
  "angles-up-down-solid": () => import("./generated/angles-up-down-solid"),
  "api": () => import("./generated/api"),
  "arrow-drop-down": () => import("./generated/arrow-drop-down"),
  "arrow-right-regular": () => import("./generated/arrow-right-regular"),
  "arrow-right": () => import("./generated/arrow-right"),
  "art-service": () => import("./generated/art-service"),
  "assign-link": () => import("./generated/assign-link"),
  "barcode-scan-regular": () => import("./generated/barcode-scan-regular"),
  "bars-filter-regular": () => import("./generated/bars-filter-regular"),
  "bookmark-regular": () => import("./generated/bookmark-regular"),
  "bookmark-solid": () => import("./generated/bookmark-solid"),
  "calendar-solid": () => import("./generated/calendar-solid"),
  "camera-regular": () => import("./generated/camera-regular"),
  "check-circle": () => import("./generated/check-circle"),
  "circle-check-regular": () => import("./generated/circle-check-regular"),
  "circle-minus-solid": () => import("./generated/circle-minus-solid"),
  "circle-navigation": () => import("./generated/circle-navigation"),
  "circle-play-solid": () => import("./generated/circle-play-solid"),
  "circle-plus-regular": () => import("./generated/circle-plus-regular"),
  "circle-question": () => import("./generated/circle-question"),
  "circle-stop-regular": () => import("./generated/circle-stop-regular"),
  "circle-xmark-solid": () => import("./generated/circle-xmark-solid"),
  "cloud-slash-regular": () => import("./generated/cloud-slash-regular"),
  "collect": () => import("./generated/collect"),
  "collection-taken": () => import("./generated/collection-taken"),
  "command-search": () => import("./generated/command-search"),
  "component": () => import("./generated/component"),
  "configure-slider": () => import("./generated/configure-slider"),
  "copy-regular": () => import("./generated/copy-regular"),
  "cost-savings-dollar": () => import("./generated/cost-savings-dollar"),
  "developing-stage": () => import("./generated/developing-stage"),
  "document-upload": () => import("./generated/document-upload"),
  "dollar-sign": () => import("./generated/dollar-sign"),
  "dot": () => import("./generated/dot"),
  "download": () => import("./generated/download"),
  "drag": () => import("./generated/drag"),
  "early-stage": () => import("./generated/early-stage"),
  "edit-pen": () => import("./generated/edit-pen"),
  "email-envelope": () => import("./generated/email-envelope"),
  "expand-regular": () => import("./generated/expand-regular"),
  "expand": () => import("./generated/expand"),
  "eye-slash-regular": () => import("./generated/eye-slash-regular"),
  "flash-auto": () => import("./generated/flash-auto"),
  "flash-off": () => import("./generated/flash-off"),
  "flash-on": () => import("./generated/flash-on"),
  "gauge-max-solid-full": () => import("./generated/gauge-max-solid-full"),
  "grid": () => import("./generated/grid"),
  "grip-drag": () => import("./generated/grip-drag"),
  "hazardous": () => import("./generated/hazardous"),
  "hwe-sensor-triangle": () => import("./generated/hwe-sensor-triangle"),
  "invoke-reading-bolt-regular": () => import("./generated/invoke-reading-bolt-regular"),
  "invoke-reading-bolt-solid": () => import("./generated/invoke-reading-bolt-solid"),
  "line": () => import("./generated/line"),
  "logout-exit": () => import("./generated/logout-exit"),
  "marketplace": () => import("./generated/marketplace"),
  "mature-stage": () => import("./generated/mature-stage"),
  "message": () => import("./generated/message"),
  "microphone-solid": () => import("./generated/microphone-solid"),
  "minus": () => import("./generated/minus"),
  "new-message": () => import("./generated/new-message"),
  "new-nxt-step": () => import("./generated/new-nxt-step"),
  "note-regular": () => import("./generated/note-regular"),
  "paper-plane-top": () => import("./generated/paper-plane-top"),
  "partners": () => import("./generated/partners"),
  "phone": () => import("./generated/phone"),
  "qr-code-scan": () => import("./generated/qr-code-scan"),
  "quarterly-collection": () => import("./generated/quarterly-collection"),
  "report-error-square-regular": () => import("./generated/report-error-square-regular"),
  "rotate": () => import("./generated/rotate"),
  "save": () => import("./generated/save"),
  "send": () => import("./generated/send"),
  "service": () => import("./generated/service"),
  "settings-cog-solid": () => import("./generated/settings-cog-solid"),
  "share": () => import("./generated/share"),
  "signal-connection": () => import("./generated/signal-connection"),
  "signal": () => import("./generated/signal"),
  "sort-lines": () => import("./generated/sort-lines"),
  "stacked-images-regular": () => import("./generated/stacked-images-regular"),
  "sync": () => import("./generated/sync"),
  "tag": () => import("./generated/tag"),
  "temperature-high-regular-full": () => import("./generated/temperature-high-regular-full"),
  "thumbs-down": () => import("./generated/thumbs-down"),
  "thumbs-up": () => import("./generated/thumbs-up"),
  "trash-delete-bin": () => import("./generated/trash-delete-bin"),
  "triangle-exclamation-solid": () => import("./generated/triangle-exclamation-solid"),
  "ultrasound": () => import("./generated/ultrasound"),
  "up-down": () => import("./generated/up-down"),
  "vero": () => import("./generated/vero"),
  "vibration": () => import("./generated/vibration"),
  "watching": () => import("./generated/watching"),
  "wifi-exclamation-sharp-solid": () => import("./generated/wifi-exclamation-sharp-solid"),
  "wifi": () => import("./generated/wifi"),
  "zoom-in": () => import("./generated/zoom-in"),
  "zoom-out": () => import("./generated/zoom-out"),
} satisfies Record<LazyIconName, () => Promise<IconModule>>;

export type { LazyIconName };